import { RisposteChiuse, TipologiaDomandaModulo } from ".";

export class DiarioRequest {
  domandaId?: string;
  valore?: any;
}
